import {useMemo} from 'react';
import {FilterProps} from '../filter-types';
import {NetworkOptimizationStore, SpecialtyScore} from './types';
import {createFilterProps} from './create-filter-props';
import {getTabFilterConfig, NetworkAnalysisTabId} from '../../../pages/network-analysis-tab-config';

export function useSpecialtyDropdownFilter(
    noStore: NetworkOptimizationStore,
    specialtyDataSource: SpecialtyScore[],
    onChange: (value: string) => void,
    showRosterSelection: boolean,
    activeTab?: number
): FilterProps {
    return useMemo(() => {
        const getSpecialtyName = (code: string): string => {
            const specialty = specialtyDataSource.find(s => s.specialtyCode === code);
            return specialty ? specialty.name : code;
        };

        const data = specialtyDataSource.map((score) => score.specialtyCode);
        const disabled = !noStore.appliedGeographyFilter.standard_type;

        // Get multi-select configuration from centralized tab config
        const tabConfig = activeTab !== undefined ? getTabFilterConfig(activeTab as NetworkAnalysisTabId) : null;
        const multiSelectConfig = !showRosterSelection && tabConfig?.specialty.multiSelect
            ? tabConfig.specialty.multiSelect
            : undefined;

        return createFilterProps(
            {
                label: 'Specialty',
                data,
                value: noStore.specialtyFilter,
                onChange,
                children: [
                    (item: any) => item,
                    (item: any) => getSpecialtyName(item) || 'All',
                ],
                spinner: noStore.loadingSpecialtyData,
                disabled,
                itemToString: getSpecialtyName,
                testId: 'specialty-dropdown',
            },
            multiSelectConfig
        );
    }, [
        specialtyDataSource,
        noStore.specialtyFilter,
        noStore.loadingSpecialtyData,
        noStore.appliedGeographyFilter.standard_type,
        noStore.maxSpecialtySelection,
        onChange,
        showRosterSelection,
        activeTab,
    ]);
}
